// extracted by mini-css-extract-plugin
export var active = "_l-9";
export var backButton = "_l-8";
export var clone = "_l-e";
export var collapseBar = "_l-k";
export var collapseMode = "_l-m";
export var collapsed = "_l-o";
export var dimmed = "_l-i";
export var dragHandle = "_l-c";
export var dropdownIcon = "_l-g";
export var expanding = "_l-n";
export var hidden = "_l-x";
export var iconContainer = "_l-q";
export var iconSwapper = "_l-w";
export var navItem = "_l-6";
export var navItemIcon = "_l-f";
export var navProfile = "_l-7";
export var notificationCountBadge = "_l-j";
export var notificationDot = "_l-r";
export var optionsContainer = "_l-h";
export var primaryNav = "_l-0";
export var primaryNavDivider = "_l-v";
export var primaryNavResizeHandle = "_l-2";
export var primaryNavResizing = "_l-1";
export var primaryNavTabSection = "_l-u";
export var primaryTab = "_l-p";
export var primaryTabIconBox = "_l-s";
export var secondaryNav = "_l-3";
export var selected = "_l-t";
export var settingsNav = "_l-4";
export var settingsNavItems = "_l-5";
export var show = "_l-d";
export var sideNav = "_l-l";
export var teamItem = "_l-a";
export var userProfileItem = "_l-b";